// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__btJ5R","vertical":"divider_vertical__vO8+T"};